@if (relationsInfo?.relations?.length > 0) {
  <dl class="sheet-facts">
    @for (relation of relationsInfo.relations; track relation; let i = $index) {
      <div>
        <dt>{{ i + 1 }}</dt>
        <dd>{{ relation.relation }}</dd>
      </div>
    }
  </dl>
} @else {
  <p class="sheet-empty">Nessuna relazione disponibile</p>
}
